import { render, staticRenderFns } from "./KassaSverka.vue?vue&type=template&id=68290b96&scoped=true"
import script from "./KassaSverka.vue?vue&type=script&lang=js"
export * from "./KassaSverka.vue?vue&type=script&lang=js"
import style0 from "./KassaSverka.vue?vue&type=style&index=0&id=68290b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68290b96",
  null
  
)

export default component.exports